import { instance } from '../http/axios'
import { snakeCaseObject } from '../helper/formatter'
import { Credentials, User } from '../types'

const responseBody = (response: any) => response.data

export const AuthService = {
  signUp: async (credentials: Credentials): Promise<any> =>
    instance
      .post('auth/signup', snakeCaseObject(credentials))
      .then(responseBody),
  login: async (credentials: Credentials): Promise<any> =>
    instance.post('auth/login', credentials).then(responseBody),
  logout: async (): Promise<void> => instance.delete('auth/logout'),
  sendResetCode: async (email: string): Promise<any> =>
    instance.post('auth/send_reset_code', { email }),
  resetPassword: async ({
    email,
    password,
    code,
  }: {
    email: string
    password: string
    code: string
  }): Promise<any> =>
    instance.post('auth/reset_password', {
      email,
      password,
      verificationCode: code,
    }),
  me: async (): Promise<User> => instance.get('user').then(responseBody) as any,
}
